/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorModel } from '../../models/patient-behavior-model';

export interface SavePatientBehavior$Params {
      body?: PatientBehaviorModel
}

export function SavePatientBehavior(http: HttpClient, rootUrl: string, params?: SavePatientBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBehavior.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBehaviorModel>;
    })
  );
}

SavePatientBehavior.PATH = '/api/Staff/SavePatientBehavior';
